import { render, staticRenderFns } from "./AttributePicker.vue?vue&type=template&id=23def72d&scoped=true&"
import script from "./AttributePicker.vue?vue&type=script&lang=js&"
export * from "./AttributePicker.vue?vue&type=script&lang=js&"
import style0 from "./AttributePicker.vue?vue&type=style&index=0&id=23def72d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23def72d",
  null
  
)

export default component.exports